const ChartColors = {
    ["ENCRYPT"]: { label: "Encrypt", color: "#356BC0" },
    ["MASK"]: { label: "Mask", color: "#ED88BA" },
    ["MASK_COMPLETELY"]: { label: "Mask", color: "#ED88BA" },
    ["NO_ACTION"]: { label: "No Action", color: "#EAECEF" }
};

export { ChartColors };
